module.exports = __webpack_public_path__ + "static/media/mudey-logo-white.47641e18.png";